import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import Carousel from 're-carousel';
import {BeatLoader} from "react-spinners";
import {dataRegister} from "../../services/dataRegister";
import queryString from "query-string";

class BoosterProperty extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: null,
            price: 0,
            currency: '',
            industry: '',
            location: '',
            slogans: [],
            impressions: 0,
            address: '',
            website_advertiser: null,
            image: null,
            images: [],
            duration: '',
            identifier: '',
            market_price: null,
            list_price: null,
            engagement: 0,
            reactions: 0,
            old_price: null,
            price_change: false,
            just_listed: false,
            completion_status: null,
            from_channel: "",
            click_id: ["",""],
            feed_id: "",
            check_freetext: false
        };
    };

    componentDidMount() {
        this.setState({
            lang: this.props.lang,
            market: this.props.market,
            currency: this.props.currency,
            rates: this.props.rates,
            branding: this.props.branding,
            branding_primary: this.props.branding_primary,
            format_small: this.props.format_small,
            from_channel: this.props.from_channel,
            click_id: this.props.click_id,
            feed_id: this.props.feed_id,
            check_freetext: this.props.check_freetext,
        })
    }

    componentWillReceiveProps(nextProps, nextState) {
        this.setState({
            lang: nextProps.lang,
            market: nextProps.market,
            currency: nextProps.currency,
            rates: nextProps.rates,
            format_small: nextProps.format_small,
            from_channel: nextProps.from_channel,
            click_id: nextProps.click_id,
            feed_id: nextProps.feed_id,
            check_freetext: nextProps.check_freetext,
        })
    }

    componentWillMount() {
        this.parsers.data(this.props.data);
    }

    functions = {
        link: () => {
            if (dataRegister.getDomain()) {
                if(dataRegister.getDomain() === "devyieldspotter.com"){
                    window.open("https://lp." + "devyieldlock.com" + "/" + this.state.id + "?currency=" + this.state.currency + (this.state.from_channel ? "&utm_medium=" + this.state.from_channel : "") + (this.state.check_freetext ? "&remove_media_lock=true" : "") + (this.state.click_id[0] && this.state.click_id[1]? "&" + this.state.click_id[0] + "=" + this.state.click_id[1] : "") + (this.state.feed_id? "&utm_feed" + this.state.feed_id : ""), '_blank');
                }else if(dataRegister.getDomain() === "yieldspotter.com"){
                    window.open("https://lp." + "yieldlock.com" + "/" + this.state.id + "?currency=" + this.state.currency + (this.state.from_channel ? "&utm_medium=" + this.state.from_channel : "") + (this.state.check_freetext ? "&remove_media_lock=true" : "") + (this.state.click_id[0] && this.state.click_id[1]? "&" + this.state.click_id[0] + "=" + this.state.click_id[1] : "") + (this.state.feed_id? "&utm_feed" + this.state.feed_id : ""), '_blank');
                }else{
                    window.open("https://lp." + dataRegister.getDomain() + "/" + this.state.id + "?currency=" + this.state.currency + (this.state.from_channel ? "&utm_medium=" + this.state.from_channel : "") + (this.state.check_freetext ? "&remove_media_lock=true" : "") + (this.state.click_id[0] && this.state.click_id[1]? "&" + this.state.click_id[0] + "=" + this.state.click_id[1] : "") + (this.state.feed_id? "&utm_feed" + this.state.feed_id : ""), '_blank');
                }
            } else {
                window.open("https://lp." + "devyieldlock.com" + "/" + this.state.id + "?currency=" + this.state.currency + (this.state.from_channel ? "&utm_medium=" + this.state.from_channel : "") + (this.state.check_freetext ? "&remove_media_lock=true" : "") + (this.state.click_id[0] && this.state.click_id[1]? "&" + this.state.click_id[0] + "=" + this.state.click_id[1] : "") + (this.state.feed_id? "&utm_feed" + this.state.feed_id : ""), '_blank');
            }
        }
    };

    parsers = {
        data: (data) => {
            try {
                if (data.completion_status) {
                    this.state.completion_status = data.completion_status;
                }
            } catch (e) {
            }
            try {
                //this.state.just_listed = true;
                if (data.just_listed) {
                    this.state.just_listed = data.just_listed;
                }
            } catch (e) {
            }
            try {
                //this.state.price_change = true;
                if (data.price_change) {
                    this.state.price_change = data.price_change;
                }
            } catch (e) {
            }
            try {
                //this.state.old_price = 9899999;
                if (data.old_price) {
                    this.state.old_price = data.old_price;
                }
            } catch (e) {
            }
            try {
                this.state.market_price = data.market_price;
            } catch (e) {
            }
            try {
                this.state.list_price = data.list_price;
            } catch (e) {
            }
            try {
                this.state.price = data.price;
            } catch (e) {
            }
            try {
                this.state.duration = data.duration;
            } catch (e) {
            }
            try {
                this.state.identifier = data.identifier;
            } catch (e) {
            }
            try {
                this.state.id = data.id;
            } catch (e) {
            }
            /*
            try {
                this.state.currency = data.currency;
            } catch (e) {}
            /*/
            try {
                this.state.industry = data.industry;
            } catch (e) {
            }
            try {
                if (data.location) {
                    if (typeof data.location === "object" && data.location.name) {
                        this.state.location = data.location.name;
                    } else {
                        this.state.location = data.location;
                    }
                }
            } catch (e) {
            }
            try {
                this.state.slogans = data.slogans;
            } catch (e) {
            }
            try {
                this.state.impressions = data.impressions;
            } catch (e) {
            }
            try {
                this.state.address = data.address;
            } catch (e) {
            }
            try {
                this.state.website_advertiser = data.website_advertiser;
            } catch (e) {
            }
            try {
                this.state.image = data.image;
            } catch (e) {
            }
            try {
                this.state.engagement = data.engagement.length;
            } catch (e) {}
            try {
                this.state.reactions = data.reactions.length;
            } catch (e) {}
            try {
                let images = [];
                if (data.image0) {
                    images.push(data.image0);
                }
                this.state.images = images;
            } catch (e) {
            }
            try {
                this.state.duration = data.duration;
            } catch (e) {
            }
            try {
                this.state.identifier = data.identifier;
            } catch (e) {
            }

            this.setState({
                id: this.state.id,
                price: this.state.price,
                currency: this.state.currency,
                industry: this.state.industry,
                location: this.state.location,
                slogans: this.state.slogans,
                format_small: this.state.format_small,
                impressions: this.state.impressions,
                address: this.state.address,
                website_advertiser: this.state.website_advertiser,
                image: this.state.image,
                images: this.state.images,
                duration: this.state.duration,
                identifier: this.state.identifier,
                market_price: this.state.market_price,
                list_price: this.state.list_price,
                completion_status: this.state.completion_status,
                just_listed: this.state.just_listed,
                price_change: this.state.price_change,
                old_price: this.state.old_price
            });

        }
    };

    renders = {
        numbers: (x) => {
            try {
                if (x >= 0) {
                    x = Math.round(x * 100) / 100;
                    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                }
            } catch (e) {
                return ("...")
            }
        },
        text: (item) => {
            return langRegister.get("booster-listing", item, this.state.lang);
        },
        address: () => {
            try {
                let components = this.state.address.split(/[\-]/g);
                components = components[0].split(/[\,]/);
                if (components[0] && components[0].trim() !== this.state.location.trim()) {
                    components[0] = components[0];
                    if (this.state.format_small) {
                        if (components[0].length > 30) {
                            let string = ', ' + components[0].substring(0, 30) + '...';
                            return string;
                        } else {
                            return ', ' + components[0];
                        }
                    } else {
                        if (components[0].length > 17) {
                            let string = ', ' + components[0].substring(0, 17) + '...';
                            return string;
                        } else {
                            return ', ' + components[0];
                        }
                    }
                }
            } catch (e) {
            }
        },
        location: (location, address) => {
            if (address) {
                let input = location + address;
                if (this.state.format_small) {
                    if (input.length > 30) {
                        return input.substring(0, 30) + '...';
                    } else {
                        return input
                    }
                } else {
                    if (input.length > 22) {
                        return input.substring(0, 22) + '...';
                    } else {
                        return input
                    }
                }
            } else {
                return location
            }
        },
        industry: (industry) => {
            if (industry) {
                let input = industry;
                if (this.state.format_small) {
                    if (input.length > 18) {
                        return input.substring(0, 18) + '...';
                    } else {
                        return input
                    }
                } else {
                    if (input.length > 14) {
                        return input.substring(0, 14) + '...';
                    } else {
                        return input
                    }
                }

            } else {
                return industry
            }
        },
        slogan: () => {
            try {
                return this.state.slogans[0];
            } catch (e) {
            }
        },
        price: (price) => {
            try {
                if (Math.round(this.state.rates[this.state.currency] * price)) {
                    return Math.round(this.state.rates[this.state.currency] * price);
                }
            } catch (e) {
                return '...';
            }
        }
    };

    _renderReducedPrice() {
        try {
            if (this.state.price_change && this.state.old_price > 0) {
                return Math.round(((this.state.price - this.state.old_price) / this.state.old_price) * 100);
            } else {
                return false
            }
        } catch (e) {
            return false
        }
    }

    _renderBadgeSmall() {
        try {
            if (this._renderReducedPrice() && this._renderReducedPrice() !== 0) {
                return this._renderReducedPrice() < 0 ? this._renderText("item_56") + this._renderReducedPrice() + "%" : this._renderText("item_56") + "+" + this._renderReducedPrice() + "%";
            } else if (this.state.just_listed && this.state.completion_status && this.state.completion_status.toLowerCase() !== this._renderText("item_55")) {
                //return this._renderText("item_57");
                return false;
            } else if ((!this.state.just_listed && this.state.completion_status && this.state.completion_status.toLowerCase() === this._renderText("item_55")) || (this.state.just_listed && this.state.completion_status && this.state.completion_status.toLowerCase() === this._renderText("item_55"))) {
                //return this._renderText("item_55");
                return false;
            } else {
                return false;
            }
        } catch (e) {
            return false
        }
    }

    renderLoader() {
        let query = queryString.parse(window.location.search);
        try {
            if (query.id) {
                return '#BFBFBF'
            } else {
                if (window.location.hostname.indexOf("propertybooster") !== -1) {
                    return '#33B8CF'
                } else if (window.location.hostname.indexOf("boostabostad") !== -1) {
                    return '#7ECF5B'
                } else if (window.location.hostname.indexOf("yieldlock") !== -1) {
                    return '#00273A'
                } else if (window.location.hostname.indexOf("yieldspotter") !== -1) {
                    return '#00273A'
                } else {
                    return '#ffffff'
                }
            }
        } catch (e) {
            return '#ffffff'
        }
    }

    renderPropertyBooster() {
        try {
            return window.location.hostname.indexOf("propertybooster") !== -1
        } catch (e) {
            return false
        }
    }

    renderBoostaBostad() {
        try {
            return window.location.hostname.indexOf("boostabostad") !== -1
        } catch (e) {
            return false
        }
    }

    renderYieldlock() {
        try {
            return window.location.hostname.indexOf("yieldlock") !== -1
        } catch (e) {
            return false
        }
    }

    renderYieldspotter() {
        try {
            return window.location.hostname.indexOf("yieldspotter") !== -1
        } catch (e) {
            return false
        }
    }

    _renderText(item) {
        return langRegister.get("booster-listing", item, this.state.lang);
    }

    _renderMarketPrice() {
        try {
            return this.state.market_price;
        } catch (e) {
            return false
        }
    }

    _renderListPrice() {
        try {
            return this.state.list_price;
        } catch (e) {
            return false
        }
    }

    _renderBadge() {
        return this._renderListPrice() && this._renderMarketPrice() && (this._renderMarketPrice() > this._renderListPrice()) && ((100 - ((this._renderListPrice() / this._renderMarketPrice()) * 100)) > 3);
    }

    render() {
        return (
            <div onClick={() => this.functions.link()} className={Styles.container}>
                {
                    !this.renderYieldlock() && !this.renderYieldspotter() && this._renderBadgeSmall() &&
                    <div style={this.state.branding ? { borderTop: "calc(var(--size-factor) * 70px) solid " + "#000000" } : { borderTop: "calc(var(--size-factor) * 70px) solid #000000" }} className={Styles.containerInnerRightPropertyImagetriangleSmall}></div>
                }
                {
                    !this.renderYieldlock() && !this.renderYieldspotter() && this._renderBadgeSmall() &&
                    <div style={this.state.branding ? { backgroundColor: "#000000" } : { backgroundColor: "#000000" }} className={Styles.containerInnerRightPropertyImageBadgeSmall}>
                        {this._renderBadgeSmall()}
                    </div>
                }
                {
                    !this.renderYieldlock() && !this.renderYieldspotter() && !this.state.branding && (this.state.engagement > 0 || this.state.reactions > 0) && !this._renderBadgeSmall() &&
                    <img className={Styles.sectionThreeLeftTopShareMobileHeart}
                         src={require('../../assets/images/heart_red.svg')}/>
                }
                {
                    (this.renderYieldlock() || this.renderYieldspotter()) && (this.state.engagement > 0 || this.state.reactions > 0) &&
                    <img className={Styles.sectionThreeLeftTopShareMobileHeart}
                         src={require('../../assets/images/heart_red_yl.svg')}/>
                }
                {
                    this.state.branding && (this.state.engagement > 0 || this.state.reactions > 0) && !this._renderBadgeSmall() &&
                    <div className={Styles.sectionThreeLeftTopShareMobileHeartBranding}>
                        <svg width="23px" height="22px" viewBox="0 0 125 118" xmlns="http://www.w3.org/2000/svg">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g transform="translate(0.000000, -1.000000)" fill={this.state.branding_primary}>
                                    <path d="M62.026,118.579 C61.15,118.6 60.301,118.279 59.658,117.685 C45.381,105.722 32.35,92.348 20.763,77.764 C15.294,70.871 10.417,63.529 6.184,55.816 C2.742,49.658 0.727,42.805 0.29,35.763 C0.262,26.617 3.748,17.809 10.026,11.158 C16.388,4.569 25.184,0.894 34.342,1 C40.942,1.012 47.414,2.832 53.053,6.263 C56.659,8.554 59.846,11.447 62.474,14.816 C65.064,11.413 68.258,8.514 71.895,6.263 C77.534,2.832 84.005,1.012 90.605,1 C99.716,0.9 108.462,4.577 114.764,11.158 C121.101,17.771 124.597,26.604 124.5,35.763 C124.142,42.84 122.064,49.723 118.447,55.816 C114.207,63.562 109.275,70.907 103.71,77.764 C91.978,92.329 78.845,105.709 64.5,117.711 C63.796,118.27 62.925,118.575 62.026,118.579 Z M34.316,8.631 C27.197,8.628 20.381,11.509 15.423,16.616 C10.464,21.724 7.787,28.622 8,35.737 C8,44.29 14.632,57.395 26.869,72.868 C37.406,86.242 49.196,98.578 62.079,109.71 C75.081,98.511 87.066,86.183 97.895,72.868 C110.132,57.395 116.895,44.132 116.895,35.737 C117.108,28.622 114.43,21.724 109.472,16.616 C104.514,11.509 97.697,8.628 90.579,8.631 C80.193,8.595 70.657,14.363 65.868,23.579 C65.224,24.857 63.905,25.654 62.474,25.631 C61.033,25.688 59.698,24.88 59.079,23.579 C56.788,19.159 53.364,15.426 49.158,12.763 C44.705,10.001 39.556,8.568 34.316,8.631 L34.316,8.631 Z" id="Fill-1" fill-rule="nonzero"></path>
                                    <ellipse id="Oval" cx="37" cy="36.5" rx="30" ry="29.5"></ellipse>
                                    <ellipse id="Oval-Copy" cx="89" cy="36.5" rx="30" ry="29.5"></ellipse>
                                    <ellipse id="Oval-Copy-2" cx="62" cy="74.5" rx="30" ry="29.5"></ellipse>
                                    <ellipse id="Oval" cx="45" cy="58.5" rx="24" ry="26.5"></ellipse>
                                    <ellipse id="Oval" cx="21" cy="61.5" rx="7" ry="6.5"></ellipse>
                                    <ellipse id="Oval" cx="89.5" cy="63" rx="18.5" ry="18"></ellipse>
                                    <ellipse id="Oval" cx="62.5" cy="104" rx="9.5" ry="8"></ellipse>
                                </g>
                            </g>
                        </svg>
                    </div>
                }
                {
                    !this.renderYieldlock()  && !this.renderYieldspotter() && (this.state.engagement > 0 || this.state.reactions > 0) && !this._renderBadgeSmall() &&
                    <div className={Styles.containerImageEngagement}>
                        {this.renders.numbers((parseInt(this.state.engagement) + parseInt(this.state.reactions)))}
                    </div>
                }
                {
                    (this.renderYieldlock() || this.renderYieldspotter()) && (this.state.engagement > 0 || this.state.reactions > 0) &&
                    <div className={Styles.containerImageEngagement}>
                        {this.renders.numbers((parseInt(this.state.engagement) + parseInt(this.state.reactions)))}
                    </div>
                }
                <div className={
                    cx(Styles.containerCorner,
                        {
                            [Styles.containerCornerPropertyBooster]: this.renderPropertyBooster() && !this.state.expired,
                            [Styles.containerCornerBoostaBostad]: this.renderBoostaBostad() && !this.state.expired,
                            [Styles.containerCornerYieldlock]: (this.renderYieldlock() || this.renderYieldspotter()) && !this.state.expired,
                            [Styles.containerCornerDisabled]: this.state.expired,
                        })
                }/>
                <div className={
                    cx(Styles.containerCornerGray,
                        {
                            [Styles.containerCornerGrayPropertyBooster]: this.renderPropertyBooster() && !this.state.expired,
                            [Styles.containerCornerGrayBoostaBostad]: this.renderBoostaBostad() && !this.state.expired,
                            [Styles.containerCornerGrayYieldlock]: (this.renderYieldlock() || this.renderYieldspotter()) && !this.state.expired,
                            [Styles.containerCornerGrayDisabled]: this.state.expired,
                        })
                }/>
                <div className={Styles.containerImage}>
                    <div className={Styles.containerImageLoader}>
                        <BeatLoader size={15} color={this.renderLoader()} loading={true}/>
                    </div>
                    {
                        <div style={{backgroundImage: 'url(' + this.state.images[0] + ')'}}
                             className={Styles.containerImageItem}/>
                    }
                    {
                        this.state.impressions > 0 && !this.renderYieldlock() && !this.renderYieldspotter() &&
                        <div style={this.renderYieldlock() || this.renderYieldspotter() ? {background: '#00273A'} : {}}
                             className={
                                 cx(Styles.containerImageViews,
                                     {
                                         [Styles.containerImageViewsSmall]: this.state.format_small,
                                     })
                             }>
                            {this.renders.numbers(this.state.impressions)}{this._renderText("item_1")}
                        </div>
                    }
                    {
                        (this.renderYieldlock() || this.renderYieldspotter()) &&
                        <div style={this.renderYieldlock() || this.renderYieldspotter() ? {background: '#00273A'} : {}}
                             className={
                                 cx(Styles.containerImageViews,
                                     {
                                         [Styles.containerImageViewsSmall]: this.state.format_small,
                                     })
                             }>
                            {this.state.website_advertiser}
                        </div>
                    }
                    {
                        (this.renderYieldlock() || this.renderYieldspotter()) && this._renderBadge() &&
                        <div style={this.renderYieldlock() || this.renderYieldspotter() ? {background: '#E65032'} : {}}
                             className={
                                 cx(Styles.containerImageSlogan,
                                     {
                                         [Styles.containerImageSloganSmall]: this.state.format_small,
                                     })
                             }>
                            {Math.round((100 - ((this._renderListPrice() / this._renderMarketPrice()) * 100)))}{this._renderText("item_35")}
                        </div>
                    }
                    {
                        !this.renderYieldlock() && !this.renderYieldspotter() &&
                        <div style={(this.state.branding && this.state.branding_primary) ? {backgroundColor: this.state.branding_primary} : {}} className={
                            cx(Styles.containerImageSlogan,
                                {
                                    [Styles.containerImageSloganSmall]: this.state.format_small,
                                })
                        }>
                            {this.renders.slogan()}
                        </div>
                    }
                </div>
                <div className={Styles.containerTitle}>
                    <div style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                         className={
                             cx(Styles.containerTitleText,
                                 {
                                     [Styles.containerTitleTextSmall]: this.state.format_small,
                                 })
                         }>
                        {this.state.industry ? this.renders.industry(this.state.industry[this.props.lang]) : ""}
                    </div>
                    {
                        !this.renderYieldlock() && !this.renderYieldspotter() &&
                        <div className={Styles.containerTitleStars}>
                            <img className={
                                cx(Styles.containerTitleStarsItem,
                                    {
                                        [Styles.containerTitleStarsItemSmall]: this.state.format_small,
                                    })
                            }
                                 src={require('../../assets/images/star_icon.png')}/>
                            <img className={
                                cx(Styles.containerTitleStarsItem,
                                    {
                                        [Styles.containerTitleStarsItemSmall]: this.state.format_small,
                                    })
                            }
                                 src={require('../../assets/images/star_icon.png')}/>
                            <img className={
                                cx(Styles.containerTitleStarsItem,
                                    {
                                        [Styles.containerTitleStarsItemSmall]: this.state.format_small,
                                    })
                            }
                                 src={require('../../assets/images/star_icon.png')}/>
                            <img className={
                                cx(Styles.containerTitleStarsItem,
                                    {
                                        [Styles.containerTitleStarsItemSmall]: this.state.format_small,
                                    })
                            }
                                 src={require('../../assets/images/star_icon.png')}/>
                            <img className={
                                cx(Styles.containerTitleStarsItem,
                                    {
                                        [Styles.containerTitleStarsItemSmall]: this.state.format_small,
                                    })
                            }
                                 src={require('../../assets/images/star_icon.png')}/>
                        </div>
                    }
                    {
                        (this.renderYieldlock() || this.renderYieldspotter()) &&
                        <div className={Styles.containerTitleStars}>
                            <img className={
                                cx(Styles.containerTitleStarsItem,
                                    {
                                        [Styles.containerTitleStarsItemSmall]: this.state.format_small,
                                    })
                            }
                                 src={require('../../assets/images/star_yl.png')}/>
                            <img className={
                                cx(Styles.containerTitleStarsItem,
                                    {
                                        [Styles.containerTitleStarsItemSmall]: this.state.format_small,
                                    })
                            }
                                 src={require('../../assets/images/star_yl.png')}/>
                            <img className={
                                cx(Styles.containerTitleStarsItem,
                                    {
                                        [Styles.containerTitleStarsItemSmall]: this.state.format_small,
                                    })
                            }
                                 src={require('../../assets/images/star_yl.png')}/>
                            <img className={
                                cx(Styles.containerTitleStarsItem,
                                    {
                                        [Styles.containerTitleStarsItemSmall]: this.state.format_small,
                                    })
                            }
                                 src={require('../../assets/images/star_yl.png')}/>
                            <img className={
                                cx(Styles.containerTitleStarsItem,
                                    {
                                        [Styles.containerTitleStarsItemSmall]: this.state.format_small,
                                    })
                            }
                                 src={require('../../assets/images/star_yl.png')}/>
                        </div>
                    }
                </div>
                {
                    this.state.price > 0 && this.state.identifier === "rent" &&
                    <div
                        style={(this.state.branding && this.state.branding_primary) ? {color: this.state.branding_primary} : {}}
                        className={
                        cx(Styles.containerPrice,
                            {
                                [Styles.containerPriceSmall]: this.state.format_small,
                                [Styles.containerPricePropertyBooster]: this.renderPropertyBooster() && !this.state.branding,
                                [Styles.containerPriceBoostaBostad]: this.renderBoostaBostad() && !this.state.branding,
                                [Styles.containerPriceYieldlock]: (this.renderYieldlock() || this.renderYieldspotter()) && !this.state.branding,
                            })
                    }>
                        <span className={Styles.containerPriceDot}>&bull; </span>
                        {this.state.currency}{' '}{this.renders.numbers(this.renders.price(this.state.price))}{' '}{this.state.duration}
                    </div>
                }
                {
                    this.state.price > 0 && this.state.identifier === "sale" &&
                    <div
                        style={(this.state.branding && this.state.branding_primary) ? {color: this.state.branding_primary} : {}}
                        className={
                        cx(Styles.containerPrice,
                            {
                                [Styles.containerPriceSmall]: this.state.format_small,
                                [Styles.containerPricePropertyBooster]: this.renderPropertyBooster() && !this.state.branding,
                                [Styles.containerPriceBoostaBostad]: this.renderBoostaBostad() && !this.state.branding,
                                [Styles.containerPriceYieldlock]: (this.renderYieldlock() || this.renderYieldspotter()) && !this.state.branding,
                            })
                    }>
                        <span className={Styles.containerPriceDot}>&bull; </span>
                        {this.state.currency}{' '}{this.renders.numbers(this.renders.price(this.state.price))}
                    </div>
                }
                {
                    this.state.price < 1 &&
                    <div
                        style={(this.state.branding && this.state.branding_primary) ? {color: this.state.branding_primary} : {}}
                        className={
                        cx(Styles.containerPrice,
                            {
                                [Styles.containerPriceSmall]: this.state.format_small,
                                [Styles.containerPricePropertyBooster]: this.renderPropertyBooster() && !this.state.branding,
                                [Styles.containerPriceBoostaBostad]: this.renderBoostaBostad() && !this.state.branding,
                                [Styles.containerPriceYieldlock]: (this.renderYieldlock() || this.renderYieldspotter()) && !this.state.branding,
                            })
                    }>
                        <span className={Styles.containerPriceDot}>&bull; </span>
                        {this._renderText("item_2")}
                    </div>
                }
                <div style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                     className={
                         cx(Styles.containerLocation,
                             {
                                 [Styles.containerLocationSmall]: this.state.format_small,
                             })
                     }>
                    <span className={Styles.containerLocationDot}>&bull; </span>
                    {this.renders.location(this.state.location, this.renders.address())}
                </div>
            </div>
        );
    }
}

export default BoosterProperty;


// WEBPACK FOOTER //
// ./src/components/booster-property/component.js